import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function Highlights() {
    // Sample highlights data
    const highlights = [
        {
            id: 1,
            title: "Maasai Mara Safari",
            description: "Witness the Great Migration in Kenya's premier wildlife reserve",
            url: "https://www.youtube.com/embed/Fz-m0zvHSVQ",
            price: "$1,200"
        },

        {
            id: 4,
            title: "Amboseli National Park",
            description: "The giants of Amboseli National Park",
            url: "https://www.youtube.com/embed/vrOI6osbSW8",
            price: "$950"
        }
    ];

    return (
        <>
            <Helmet>
                <title>Tour Highlights | Primedale Tours and Travel</title>
                <meta name="description" content="Discover amazing tour highlights from Primedale Tours and Travel" />
            </Helmet>



            {/* Highlights Slider */}
            <div className="container py-5">
                <h2 className="text-center mb-5">Featured Tour Highlights</h2>

                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: true }}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                    }}
                    className="highlights-slider"
                >
                    {highlights.map((highlight) => (
                        <SwiperSlide key={highlight.id}>
                            <div className="card h-100 shadow-sm" style={{
                                height: '100%',
                                minHeight: '420px',
                                maxHeight: '420px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: '12px',
                                overflow: 'hidden',
                            }}>
                                <div className="video-container" style={{
                                    position: "relative",
                                    paddingBottom: "56.25%", // Fixed 16:9 aspect ratio
                                    height: 0,
                                    overflow: "hidden",
                                    width: "100%",
                                    background: "#000",
                                    flexShrink: 0,
                                }}>
                                    <iframe
                                        src={highlight.url}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture web-share"
                                        allowFullScreen
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />
                                </div>
                                <div className="card-body" style={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '1.25rem',
                                }}>
                                    <h5 className="card-title" style={{
                                        marginBottom: '0.75rem',
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        minHeight: '2.8rem',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                    }}>
                                        {highlight.title}
                                    </h5>
                                    <p className="card-text" style={{
                                        flex: 1,
                                        fontSize: '0.95rem',
                                        color: '#6c757d',
                                        marginBottom: '1rem',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                    }}>
                                        {highlight.description}
                                    </p>
                                    <Link to="/modal" className="btn btn-primary" style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        padding: '0.6rem',
                                        borderRadius: '6px',
                                    }}>
                                        Book Now
                                    </Link>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Video Section */}
            <div className="container py-5">
                <h2 className="text-center mb-4">Experience the Adventure</h2>

                <iframe
                    src="https://www.youtube.com/embed/DF1mJAokD3g"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture web-share"
                    allowFullScreen
                    style={{
                        width: "100%",
                        height: "60vh"
                    }}
                />
            </div>

            {/* Featured Packages Section */}
            <div className="container-fluid bg-light py-5">
                <div className="container">
                    <h2 className="text-center mb-5">Why Choose Primedale?</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="text-center p-4">
                                <i className="fas fa-globe-africa fs-1 text-primary mb-3"></i>
                                <h5>Expert Local Guides</h5>
                                <p>Knowledgeable guides who know Kenya inside out</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center p-4">
                                <i className="fas fa-shield-alt fs-1 text-primary mb-3"></i>
                                <h5>Safe & Reliable</h5>
                                <p>Your safety is our top priority</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center p-4">
                                <i className="fas fa-star fs-1 text-primary mb-3"></i>
                                <h5>5-Star Service</h5>
                                <p>Personalized experiences tailored to you</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .highlights-slider .swiper-slide {
                    height: auto;
                }
                .highlights-slider .swiper-slide .card {
                    width: 100% !important;
                }
            `}</style>
        </>
    );
}

export default Highlights;